import { Navigate, useSearchParams } from "react-router-dom";
import * as myApi from "../Api";

/**
 * InactiveUserRedirect Component
 * Redirects inactive users to activation page with email parameter
 * Must be used inside Router context
 */
const InactiveUserRedirect = () => {
  const [searchParams] = useSearchParams();
  const isInactiveUser = myApi.isUserInactive();
  const currentPath = window.location.pathname;
  const currentQuery = window.location.search;
  const user = myApi.getUser();

  // Build the correct activation URL with email parameter
  const userEmail = user?.email || "";
  const activationPath = `/auth/activation/`;
  const correctQuery = userEmail ? `?email=${encodeURIComponent(userEmail)}` : "";

  // Redirect inactive users to activation page with email parameter
  if (isInactiveUser) {
    // If not on activation page at all, redirect
    if (currentPath !== "/auth/activation/") {
      return <Navigate to={`${activationPath}${correctQuery}`} replace />;
    }
    
    // If on activation page but missing email parameter, redirect with it
    if (!searchParams.has("email") && userEmail) {
      return <Navigate to={`${activationPath}${correctQuery}`} replace />;
    }
  }

  // Don't render anything if no redirect needed
  return null;
};

export default InactiveUserRedirect;
